

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createMRTColumnHelper } from "material-react-table";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";
import CustomTable from "../../components/customTable/CustomTable";
import { PartnerOrderQuoteApi } from "../../app/slices/spotGoldQuote/PartnerOrderQuoteSlice";
import { toast } from "react-toastify";
import { Box, IconButton, Tooltip, } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";


export default function PartnerOrderQuote() {
  const dispatch = useDispatch();
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });
  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };
  useEffect(() => {
    dispatch(PartnerOrderQuoteApi(queryParams));
  }, [dispatch, queryParams]);

  const sliceResponse = useSelector((state) => state.PartnerOrderQuote.PartnerOrderQuote.data);
  const stateLoading = useSelector(
    (state) => state.PartnerOrderQuote.loading
  );
  const [showData, setShowData] = useState([]);

  // useEffect(() => {
  //   if (sliceResponse?.length > 0) {
  //     const formattedData = sliceResponse.map((originalData) => {
  //       const product = originalData.productDetails[0] || {}; // Handle cases where productDetails might be empty
  //       return {
  //         id: originalData._id,
  //         clientId: originalData.client_id,
  //         partnerId: originalData.partner_id,
  //         orderNo: originalData.order_no,
  //         productId: product.productId || "N/A",
  //         quantity: product.quantity || "N/A",
  //         paymentTypeId: product.paymentTypeId || "N/A",
  //         productImg: product.product_img || "N/A",
  //         metalType: product.metal_type || "N/A",
  //         productName: product.productName || "N/A",
  //         weight: product.weight || "N/A",
  //         finalOrderPrice: product.finalOrderPrice || "N/A",
  //         firstName: originalData.firstName,
  //         lastName: originalData.lastName,
  //         email: originalData.email,
  //         landMark: originalData.landMark,
  //         customerAddress: originalData.customerAddress,
  //         postalCode: originalData.postalCode,
  //         stateName: originalData.stateName,
  //         cityName: originalData.cityName,
  //         panCardNumber: originalData.panCardNumber,
  //         dateOfBirth: originalData.dateOfBirth,
  //         mobileNumber: originalData.mobileNumber,
  //         transactionId: originalData.transactionId,
  //         shippingAddress: originalData.shippingAddress,
  //         shippingLandMark: originalData.shippingLandMark,
  //         shippingPostalCode: originalData.shippingPostalCode,
  //         shippingStateName: originalData.shippingStateName,
  //         shippingCityName: originalData.shippingCityName,
  //         status: originalData.status,
  //         isDeleted: originalData.is_deleted,
  //         createdAt: originalData.createdAt,
  //         updatedAt: originalData.updatedAt,
  //         razorpayOrderId: originalData.razorpay_order_id || originalData.orderId
  //       };
  //     });
  //     setShowData(formattedData);
  //   } else {
  //     setShowData([]);
  //   }
  // }, [sliceResponse]);


  useEffect(() => {
    if (sliceResponse?.length > 0) {
      const formattedData = sliceResponse.map((originalData) => {
        // Check if productDetails is an array and has at least one item
        const product =
          Array.isArray(originalData.productDetails) &&
            originalData.productDetails.length > 0
            ? originalData.productDetails[0]
            : {};

        return {
          id: originalData._id,
          clientId: originalData.client_id || "N/A",
          customerRefNo: originalData.customerRefNo || "N/A",
          partnerId: originalData.partner_id || "N/A",
          orderNo: originalData.order_no || "N/A",
          productId: product.productId || "N/A",
          quantity: product.quantity || "N/A",
          paymentTypeId: product.paymentTypeId || "N/A",
          productImg: product.product_img || "N/A",
          metalType: product.metal_type || "N/A",
          productName: product.productName || "N/A",
          weight: product.weight || "N/A",
          finalOrderPrice: product.finalOrderPrice || "N/A",
          firstName: originalData.firstName || "N/A",
          lastName: originalData.lastName || "N/A",
          email: originalData.email || "N/A",
          landMark: originalData.landMark || "N/A",
          customerAddress: originalData.customerAddress || "N/A",
          postalCode: originalData.postalCode || "N/A",
          stateName: originalData.stateName || "N/A",
          cityName: originalData.cityName || "N/A",
          panCardNumber: originalData.panCardNumber || "N/A",
          dateOfBirth: originalData.dateOfBirth || "N/A",
          mobileNumber: originalData.mobileNumber || "N/A",
          transactionId: originalData.transactionId || "N/A",
          shippingAddress: originalData.shippingAddress || "N/A",
          shippingLandMark: originalData.shippingLandMark || "N/A",
          shippingPostalCode: originalData.shippingPostalCode || "N/A",
          shippingStateName: originalData.shippingStateName || "N/A",
          shippingCityName: originalData.shippingCityName || "N/A",
          status: originalData.status || "N/A",
          isDeleted: originalData.is_deleted || "N/A",
          createdAt: originalData.createdAt || "N/A",
          updatedAt: originalData.updatedAt || "N/A",
          OrderId: originalData.razorpay_order_id || originalData.orderId || "N/A",
          payment_id: originalData.payment_id || "N/A",
          merchantOrderId: originalData.merchant_order_id || "N/A",
        };
      });
      setShowData(formattedData);
    } else {
      setShowData([]);
    }
  }, [sliceResponse]);


  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("id", {
      header: "ID",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.id);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),

    // columnHelper.accessor("clientId", {
    //   header: "Client ID",
    //   size: 150,
    // }),
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <div>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo || "N/A"}
            </div>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("clientId", {
      header: "Client ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.clientId);
          toast.success("copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row.original?.clientId}>
            <div>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.clientId}
            </div>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("partnerId", {
      header: "Partner ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?.partnerId);
          toast.success("Copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row?.original?.partnerId}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),

    // columnHelper.accessor("partnerId", {
    //   header: "Partner ID",
    //   size: 150,
    // }),

    columnHelper.accessor("orderNo", {
      header: "Order No",
      size: 100,
    }),

    // columnHelper.accessor("productId", {
    //   header: "Product ID",
    //   size: 150,
    // }),

    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 100,
    }),

    // columnHelper.accessor("paymentTypeId", {
    //   header: "Payment Type ID",
    //   size: 150,
    // }),

    columnHelper.accessor("productImg", {
      header: "Product Image",
      size: 200,
      Cell: ({ cell }) => (
        <img
          src={cell.row.original?.productImg}
          alt="Product"
          style={{ width: "50px", height: "50px" }}
        />
      ),
    }),

    columnHelper.accessor("metalType", {
      header: "Metal Type",
      size: 150,
    }),

    columnHelper.accessor("productName", {
      header: "Product Name",
      size: 200,
    }),

    columnHelper.accessor("weight", {
      header: "Weight",
      size: 100,
    }),

    columnHelper.accessor("finalOrderPrice", {
      header: "Final Order Price",
      size: 150,
    }),

    columnHelper.accessor("firstName", {
      header: "First Name",
      size: 150,
    }),

    columnHelper.accessor("lastName", {
      header: "Last Name",
      size: 150,
    }),

    columnHelper.accessor("email", {
      header: "Email",
      size: 200,
    }),

    columnHelper.accessor("landMark", {
      header: "Landmark",
      size: 200,
    }),

    columnHelper.accessor("customerAddress", {
      header: "Customer Address",
      size: 250,
    }),

    columnHelper.accessor("postalCode", {
      header: "Postal Code",
      size: 100,
    }),

    columnHelper.accessor("stateName", {
      header: "State Name",
      size: 150,
    }),

    columnHelper.accessor("cityName", {
      header: "City Name",
      size: 150,
    }),

    columnHelper.accessor("panCardNumber", {
      header: "PAN Card Number",
      size: 200,
    }),

    columnHelper.accessor("dateOfBirth", {
      header: "Date of Birth",
      size: 150,
    }),

    columnHelper.accessor("mobileNumber", {
      header: "Mobile Number",
      size: 150,
    }),

    columnHelper.accessor("transactionId", {
      header: "Transaction ID",
      size: 250,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.transactionId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.transactionId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.transactionId}
            </span>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("shippingAddress", {
      header: "Shipping Address",
      size: 250,
    }),

    columnHelper.accessor("shippingLandMark", {
      header: "Shipping Landmark",
      size: 200,
    }),

    columnHelper.accessor("shippingPostalCode", {
      header: "Shipping Postal Code",
      size: 150,
    }),

    columnHelper.accessor("shippingStateName", {
      header: "Shipping State Name",
      size: 150,
    }),

    columnHelper.accessor("shippingCityName", {
      header: "Shipping City Name",
      size: 150,
    }),
    columnHelper.accessor("OrderId", {
      header: "Order ID",
      size: 250,
    }),
    columnHelper.accessor("payment_id", {
      header: "Payment ID",
      size: 250,
    }),
    columnHelper.accessor("merchantOrderId", {
      header: "Merchant Order ID",
      size: 250,
    }),
    columnHelper.accessor("status", {
      header: "Status",
      size: 100,
    }),

    // columnHelper.accessor("isDeleted", {
    //   header: "Is Deleted",
    //   size: 100,
    // }),

    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 150,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original.createdAt.split("T")[0]}
        </div>
      ),
    }),

    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 150,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original.updatedAt.split("T")[0]}
        </div>
      ),
    }),


  ];



  return (
    <div>
      <DateSearchComponent onSearch={handleSearch} />
      <Box mt={2}>
        <CustomTable columns={columns} data={showData}
          loading={stateLoading}
          permissionKey="SpotGoldQueries"
        />
      </Box>
    </div>
  )
}
